import { merge } from '../../../helper';

import { create as exCreate } from '../create';

// ----------------------------------------------------------------------------

function data(config: Record<string, any> = {}): Record<string, any> {
    const defConfig: Record<string, any> = {};

    merge(defConfig, config);

    const src: Record<string, any> = {
        elements: [],
        list: [],
    };

    for (const itemConfig of defConfig.data) {
        const defItemConfig = {
            ...defConfig,
            ...itemConfig,
        };

        const checkbox = exCreate(defItemConfig);

        if (defConfig.value != null && defConfig.value === checkbox.input.element.name) {
            checkbox.input.element.checked = true;
        }

        src.elements.push(checkbox.element);
        src.list.push(checkbox);
    }

    return src;
}

// ----------------------------------------------------------------------------

export default data;
